import { useRouter } from 'next/router'

import { OnboardingRouteParams, readOnboardingRouteParams } from '../shared/OnboardingRouteParams'

export function useOnboardingRouteParams(): OnboardingRouteParams {
  const router = useRouter()
  return readOnboardingRouteParams(router.query)
}
